import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, DEG_TO_RAD, Sprite, TextStyle, Text } from "pixi.js";
import tools from "tools";
const DEFAULT_SCALE = .8;
const DOWN_SCALE = .7;
export default class HomeBtn extends Container {
  constructor(picto, label, fontSize = 30) {
    super();
    tools.autobind(this);
    this.btn = new Sprite(picto);
    this.btn.scale.set(DEFAULT_SCALE);
    this.btn.anchor.set(.5, 0);
    this.addChild(this.btn);
    this.alert = new Sprite(assets.textures.alertIcon.texture);
    this.alert.x = -this.btn.width / 2 + 5;
    this.alert.y = 10;
    this.alert.visible = false;
    this.alert.scale.set(.8);
    this.alert.anchor.set(.5);
    gsap.to(this.alert.scale, {
      duration: .5,
      x: 1,
      y: 1,
      yoyo: true,
      repeat: -1
    });
    this.btn.addChild(this.alert);
    this.interactive = true;
    this.buttonMode = true;
    this.on('pointerdown', this.onDown);
    this.on('pointerup', this.onUp);
    this.on('pointerupoutside', this.onOut);
    if (label) {
      const textStyle = new TextStyle({
        fontFamily: 'Anja Eliane accent',
        fontSize: fontSize,
        align: "center",
        fill: 0xffffff,
        stroke: '#222222',
        strokeThickness: 5,
        lineHeight: 30,
        wordWrap: true,
        wordWrapWidth: 150
      });
      this._text = new Text(label, textStyle);
      this._text.anchor.x = .5;
      this._text.anchor.y = 0;
      this._text.y = this.btn.height + 10;
      this.btn.addChild(this._text);
      if (this._text.width > 200) {
        textStyle.fontSize = 20;
        this._text.y = this.btn.height + 20;
      }
    }
  }
  onDown(event) {
    if (!this._down) {
      this._down = true;
      gsap.to(this.btn.scale, {
        duration: .2,
        x: DOWN_SCALE,
        y: DOWN_SCALE
      });
    }
  }
  onUp(event) {
    if (this._down) {
      gsap.to(this.btn.scale, {
        duration: .2,
        x: DEFAULT_SCALE,
        y: DEFAULT_SCALE
      });
      this._callBack && this._callBack();
    }
    this._down = false;
  }
  onOut(event) {
    this._down = false;
    gsap.to(this.btn.scale, {
      duration: .2,
      x: DEFAULT_SCALE,
      y: DEFAULT_SCALE
    });
  }
  set click(callBack) {
    this._callBack = callBack;
  }
  set tint(color) {
    this.btn.tint = color;
    if (color == 0x777777) {
      this._text.visible = false;
    } else {
      this._text.visible = true;
    }
  }
  get initScale() {
    return 1;
  }
  set showAlert(val) {
    this.alert.visible = val;
  }
}
